













import { IEmployeeFormSubmission } from '@/models';

import Vue, { PropType } from 'vue';
export default Vue.extend({
  name: 'EmployeeFormSubmissionStatusDisplay',

  props: {
    employeeFormSubmission: {
      type: Object as PropType<IEmployeeFormSubmission>,
      required: true
    }
  }
});
